"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var isOnline = mobx_1.observable.box(navigator.onLine);
window.addEventListener('offline', function () { return isOnline.set(false); });
window.addEventListener('online', function () { return isOnline.set(true); });
exports.isNetworkOnline = function () { return isOnline.get(); };
exports.isNetworkOffline = function () { return !isOnline.get(); };
function whenGoingOnline(cb) {
    return isOnline.observe(function (change) {
        if (change.oldValue === false && change.newValue === true) {
            cb();
        }
    });
}
exports.whenGoingOnline = whenGoingOnline;
//# sourceMappingURL=offline.js.map